"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Crease_1 = require("../core/Crease");
class MetaCrease extends Crease_1.Crease {
    get vertices() {
        return super.vertices;
    }
    get edges() {
        return super.edges;
    }
    get faces() {
        return super.faces;
    }
}
exports.MetaCrease = MetaCrease;
//# sourceMappingURL=MetaCrease.js.map